export class Coordinate {
    coordX:number;
    coordY:number;
  }
  